import { Outlet } from 'react-router-dom'
import { Header } from './Header'
import { HeaderProvider } from './HeaderContext'
import { memo } from 'react'
import { Footer } from './Footer'

export function MainLayout() {
  return (
    <div className="grid h-screen w-screen grid-rows-[43px_1fr_43px]">
      <HeaderProvider>
        <Header />
        <MainContent />
        <Footer />
      </HeaderProvider>
    </div>
  )
}

const MainContent = memo(() => (
  <div className="h-[calc(100vh-86px)] overflow-y-auto bg-background">
    <Outlet />
  </div>
))
